<template>
  <div class="blacklist-container">
    <div class="search-bar">
      <el-button icon="el-icon-refresh" @click="handleSearch"></el-button>
    </div>

    <el-table v-loading="loading" :data="tableData" border style="width: 100%">
      <el-table-column prop="ip" label="IP地址" width="180"> </el-table-column>
      <el-table-column prop="banTime" label="封禁时间" width="180">
        <template slot-scope="scope">
          {{ formatTime(scope.row.banTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="reason" label="封禁原因"> </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" @click="handleUnblock(scope.row)">解封</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { queryBlacklist, unblockIp } from '@/api/blacklist';

export default {
  name: 'Blacklist',
  data() {
    return {
      // 表格数据
      tableData: [],
      // 加载状态
      loading: false,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    formatTime(time) {
      if (!time) return '';
      const date = new Date(time);
      return date.toLocaleString('zh-CN', {
        timeZone: 'Asia/Shanghai',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      });
    },
    // 获取黑名单列表数据
    fetchData() {
      this.loading = true;
      queryBlacklist()
        .then((res) => {
          this.tableData = res;
        })
        .catch((error) => {
          this.$message.error('获取黑名单列表失败');
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 搜索
    handleSearch() {
      this.fetchData();
    },

    // 解封IP
    handleUnblock(row) {
      this.$confirm('确认解封该IP?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          unblockIp(row.id)
            .then((res) => {
              if (res !== true) {
                this.$message.error('解封失败');
                return;
              }
              this.$message({
                type: 'success',
                message: '解封成功!',
              });
              this.fetchData();
            })
            .catch((error) => {
              this.$message.error('解封失败');
              console.error(error);
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消解封',
          });
        });
    },
  },
};
</script>

<style scoped>
.blacklist-container {
  padding: 20px;
}
.search-bar {
  margin-bottom: 20px;
  text-align: left;
}
</style>
